export function purchaseOrderPdfFileName(poNumber: string | undefined, purchaseOrderId: string): string {
  const base = poNumber?.trim()
    ? `purchase-order-${poNumber.replace(/[^a-zA-Z0-9-_]+/g, '-')}`
    : `purchase-order-${purchaseOrderId}`;
  return base.endsWith('.pdf') ? base : `${base}.pdf`;
}

export function triggerBlobDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
